const recommendList = () => import('@/pages/product/recommend/index.vue');

export default [{
    path: '/product/recommend',
    component: recommendList,
    meta: [{
        name: '产品管理',
		activeRoute: '/product/manage'
    },
    {
        name: '推荐列表',
        activeRoute: '/product/recommend'
    }]
}];